import React, { useContext, useEffect, useState } from "react";
import AppHeader from "../Header/NewHeader";
import AppBody from "../Body";
import AppFooter from "../Footer";
import debounce from "lodash.debounce";
import Axios from "axios";
import NoAccess from "../Shared/NoAccess";
import Loader from "../Loader";
import mixpanel from "mixpanel-browser";
import "./AppLayout.css";
import HeaderMobile from "../Header/HeaderMobile";
import { isMobile, currentRequestTimeStamp, resolveScreenParam } from "../../Constants";
import Maintenance from "../Maintenance";
import { UserApiContext } from "../UserDetailsContext/UserDetailsContext";
import PrivateRoute from "../../PrivateRoute";
import { MyCompanyProfileContext } from "../../MyCompanyProfileContext";
import PermissionDenied from "../Shared/PermissionDenied/PermissionDenied";
import PolicyBlocked from "../Shared/PolicyBlocked/PolicyBlocked";
import { Urls } from "../../Urls";
import { useMixPanelForTracking } from "../../utils/TrackMixPanel";
import useIsMobile from "../../hooks/useIsMobile";
import { mailerAPI } from "../Freightrates1/Utility";

const sendBlockedLoginAlert = (userEmail, domainStatus) => {
  const attempted_at = new Date().toLocaleString();
  userEmail = userEmail || "(unknown)";
  domainStatus = domainStatus || "(unknown)";
  if (userEmail === "(unknown)" || domainStatus === "(unknown)") {
    console.warn("sendBlockedLoginAlert: missing userEmail/domainStatus", { userEmail, domainStatus });
  }
  mailerAPI({
    activity: "Email Request",
    type: "superlaunch",
    mail_status: "Pending",
    from_email: "connect@logisticsnow.in",
    user_type: "company",
    subject: `Blocked Login Alert: ${userEmail} attempted to access LoRRI`,
    content: `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"/><meta name="viewport" content="width=device-width, initial-scale=1.0"/><meta name="color-scheme" content="only light"/><meta name="supported-color-schemes" content="only light"/><title>Blocked Login Attempt</title></head><body style="margin:0;padding:0;background-color:#f3f6fb;font-family:'Segoe UI',Arial,sans-serif;color:#172033;"><table width="100%" cellpadding="0" cellspacing="0" role="presentation" bgcolor="#f3f6fb" style="background-color:#f3f6fb;padding:40px 16px;"><tr><td align="center"><table width="580" cellpadding="0" cellspacing="0" role="presentation" bgcolor="#ffffff" style="width:100%;max-width:580px;background-color:#ffffff;border:1px solid #d8e0ec;border-radius:16px;overflow:hidden;box-shadow:0 10px 28px rgba(23,32,51,0.08);"><tr><td bgcolor="#ffffff" style="background-color:#ffffff;padding:30px 34px 22px;border-top:5px solid #dc2626;border-bottom:1px solid #e6edf5;"><p style="margin:0 0 8px;font-size:11px;font-weight:800;letter-spacing:1.6px;text-transform:uppercase;color:#dc2626;">Internal Notification</p><h1 style="margin:0;font-size:25px;line-height:1.3;font-weight:800;color:#172033;">Blocked Login Attempt</h1><p style="margin:10px 0 0;font-size:14px;line-height:1.6;color:#526071;">A login was blocked on the LoRRI platform due to an unauthorized domain.</p></td></tr><tr><td bgcolor="#ffffff" style="background-color:#ffffff;padding:22px 34px 0;"><table width="100%" cellpadding="0" cellspacing="0" role="presentation" bgcolor="#fff7f7" style="background-color:#fff7f7;border:1px solid #fecaca;border-radius:12px;"><tr><td style="padding:15px 18px;border-left:4px solid #dc2626;"><p style="margin:0;font-size:14px;line-height:1.5;font-weight:800;color:#b91c1c;">Login blocked — domain not authorized</p><p style="margin:4px 0 0;font-size:13px;line-height:1.5;color:#526071;">Review the details below for internal records.</p></td></tr></table></td></tr><tr><td bgcolor="#ffffff" style="background-color:#ffffff;padding:26px 34px 10px;"><p style="margin:0 0 14px;font-size:12px;font-weight:800;letter-spacing:1.1px;text-transform:uppercase;color:#334155;">Attempt Details</p><table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;"><tr><td style="padding:14px 0;border-top:1px solid #e5eaf2;"><table width="100%" cellpadding="0" cellspacing="0" role="presentation"><tr><td width="36%" valign="top" style="font-size:13px;line-height:1.5;color:#64748b;padding-right:12px;">Email</td><td valign="top" style="font-size:14px;line-height:1.5;font-weight:800;word-break:break-word;"><a href="mailto:${userEmail}" style="color:#dc2626;text-decoration:none;">${userEmail}</a></td></tr></table></td></tr><tr><td style="padding:14px 0;border-top:1px solid #e5eaf2;"><table width="100%" cellpadding="0" cellspacing="0" role="presentation"><tr><td width="36%" valign="top" style="font-size:13px;line-height:1.5;color:#64748b;padding-right:12px;">Domain Status</td><td valign="top" style="font-size:14px;line-height:1.5;font-weight:800;color:#172033;word-break:break-word;">${domainStatus}</td></tr></table></td></tr><tr><td style="padding:14px 0;border-top:1px solid #e5eaf2;border-bottom:1px solid #e5eaf2;"><table width="100%" cellpadding="0" cellspacing="0" role="presentation"><tr><td width="36%" valign="top" style="font-size:13px;line-height:1.5;color:#64748b;padding-right:12px;">Attempted At</td><td valign="top" style="font-size:14px;line-height:1.5;font-weight:800;color:#172033;word-break:break-word;">${attempted_at}</td></tr></table></td></tr></table></td></tr><tr><td bgcolor="#ffffff" style="background-color:#ffffff;padding:18px 34px 28px;"><p style="margin:0;font-size:12px;line-height:1.6;color:#7b8794;text-align:center;">This is an automated internal alert from LoRRI. Please do not reply to this email.</p></td></tr><tr><td bgcolor="#f8fafc" style="background-color:#f8fafc;border-top:1px solid #e5eaf2;padding:15px 34px;text-align:center;"><p style="margin:0;font-size:12px;line-height:1.5;font-weight:800;color:#1a3c6e;">Team LoRRI <span style="color:#a3adba;">&bull;</span> LogisticsNow</p></td></tr></table></td></tr></table></body></html>`,
    Application_name: "lorri",
    module_name: "Login",
    timestamp: currentRequestTimeStamp(),
    to_email: "raj@logisticsnow.ai",
    cc: [
      "radhika@logisticsnow.ai",
      "anvit@logisticsnow.ai",
      "sanket@logisticsnow.ai",
      "smeet@logisticsnow.ai",
      "shaleen@logisticsnow.ai",
      "akhil@logisticsnow.ai",
      "tejas@logisticsnow.ai",
      "saima@logisticsnow.ai",
    ],
  }, null, "", "Failed to send blocked login alert email");
};

const AppLayout = () => {
  let States = {
    Initial: 1,
    Allowed: 2,
    Denied: 3,
    Maintenance: 4,
    PolicyBlocked: 5,
  };
  const [hasAccess, setHasAccess] = useState(States.Initial);
  const [showLoader, setShowLoader] = useState(false);
  const [user, setuser] = useState();
  const [landing_page, setLanding_page] = useState("");
  const { users, userDetails } = useContext(UserApiContext);
  const invalidAccess = "not verified";
  const { isUserinTeams, companySettingData } = useContext(MyCompanyProfileContext);
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);
  const isMobile = useIsMobile();

  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);

      try {
        if (users.user_details && userDetails) {
          // localStorage.setItem(
          //   "profile_company_id",
          //   userDetails.profile_company_id || userDetails.email
          // );
          setuser(users.user_details);
          // localStorage.setItem(
          //   "oid",
          //   users.user_details.oid
          //     ? users.user_details.oid
          //     : users.user_details.user_id
          // );
          // localStorage.setItem("user_id", users?.user_details?.user_id);
          // localStorage.setItem(
          //   "user_name",
          //   users.user_details && users.user_details.name && users.user_details.name != ""
          //     ? users.user_details.name
          //     : users.user_details.email.split("@")[0].split(".")[0]
          // );

          const matchedRoute = resolveScreenParam(window.location.search);
          const rawLandingPage = matchedRoute ?? (userDetails?.on_request?.landing_page ?? "locationdashboard");
          setLanding_page(
            rawLandingPage === "benchmarknow" || rawLandingPage === "LoRRIBenchmark"
              ? "LoRRIBenchmark"
              : rawLandingPage
          );
          // localStorage.setItem(
          //   "userdetails",
          //   users && users.user_details && users.user_details.name
          //     ? users.user_details.name
          //     : userDetails.display_name
          //     ? userDetails.display_name
          //     : ""
          // );
          // localStorage.setItem(
          //   "companyname",
          //   userDetails.company_name
          //     ? userDetails.company_name
          //     : userDetails.email
          //     ? userDetails.email.split("@")[1].split(".")[0]
          //     : ""
          // );
          mixpanel.identify(
            users && users.user_details && users.user_details.name
              ? users.user_details.name
              : userDetails.display_name
              ? userDetails.display_name
              : ""
          );
          mixpanel.register({
            user_id: users.user_details.oid
              ? users.user_details.oid
              : users.user_details.user_id,
            user_name:
              users && users.user_details && users.user_details.name
                ? users.user_details.name
                : userDetails.display_name
                ? userDetails.display_name
                : "",
            user_email:
              users.user_details.emails && users.user_details.emails.length > 0
                ? users.user_details.emails[0]
                : users.user_details.email,
            time: currentRequestTimeStamp(),
            clientIP: sessionStorage.getItem("ClientIP"),
            ApplicationName: `${Urls.mixpanelappname}`,
          });
          
          TrackMixPanel({
            ModuleName: "App Layout",
            ScreenName: "Landing Page",
            Definition: "user session started",
          });

          // if (
          //   users.user_details.emails &&
          //   users.user_details.emails.length > 0
          // ) {
          //   localStorage.setItem("useremail", users.user_details.emails);
          // } else {
          //   localStorage.setItem("useremail", users.user_details.email);
          // }
          // localStorage.setItem(
          //   "companyid",
          //   users.user_details.oid
          //     ? users.user_details.oid
          //     : users.user_details.user_id
          // ); // Used for creating PPT, should not be manipulated for any purpose

          const activeDomainStatus =
            userDetails?.domain_status || users?.user_details?.domain_status || users?.domain_status;
          const activeAccountStatus =
            userDetails?.account_status || users?.user_details?.account_status || users?.account_status;
          const activeEmail =
            userDetails?.email || users?.user_details?.email || users?.email;

          const activePolicyType =
            userDetails?.policy?.type || users?.user_details?.policy?.type;

          if (activeDomainStatus) {
            setShowLoader(false);
            if (activePolicyType === "demo" || activePolicyType === "basic") {
              setHasAccess(States.PolicyBlocked);
            } else if (
              activeDomainStatus === invalidAccess ||
              activeAccountStatus === "blocked"
            ) {
              sendBlockedLoginAlert(activeEmail, activeDomainStatus || activeAccountStatus);
              setHasAccess(States.Denied);
            } else {
              setHasAccess(States.Allowed);
            }
          }
          setShowLoader(false);
        }
      } catch (error) {
        setShowLoader(false);

        const activeDomainStatus =
          userDetails?.domain_status || users?.user_details?.domain_status || users?.domain_status;
        const activeAccountStatus =
          userDetails?.account_status || users?.user_details?.account_status || users?.account_status;
        const activeEmail =
          userDetails?.email || users?.user_details?.email || users?.email;
        const activePolicyType =
          userDetails?.policy?.type || users?.user_details?.policy?.type;

        if (activePolicyType === "demo" || activePolicyType === "basic") {
          setHasAccess(States.PolicyBlocked);
        } else if (
          activeDomainStatus === invalidAccess ||
          activeAccountStatus === "blocked"
        ) {
          sendBlockedLoginAlert(activeEmail, activeDomainStatus || activeAccountStatus);
          setHasAccess(States.Denied);
        } else {
          setHasAccess(States.Allowed);
        }
      }
    };

    fetchData();
    setVh();
    window.addEventListener("resize", debounce(setVh, 200), false);

    return () => {
      window.removeEventListener("resize", setVh, false);
    };
  }, [userDetails]);

  // useEffect(()=>{
  //   Axios.get('https://api.ipify.org?format=json')
  //   .then(res =>
  //     sessionStorage.setItem("ClientIP", res.data.ip)
  //   )
  // },[])

  const setVh = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  return (
    <>
      <PrivateRoute>
        <>
          {hasAccess === States.Allowed ? (
            <div className="app-layout">
              {isMobile ? (
                <HeaderMobile isUserinTeams={isUserinTeams} userDetails={userDetails} />
              ) : (
                <AppHeader
                  isUserinTeams={isUserinTeams}
                  landing_page={landing_page}
                  setlanding_page={setLanding_page}
                  appuser={user}
                  userData={user}
                  userDetails={userDetails}
                />
              )}
              {isUserinTeams === false ? (
                <PermissionDenied />
              ) : (
                  <AppBody landing_page={landing_page} />
              )}
              <AppFooter />
            </div>
          ) : null}
          {hasAccess === States.Maintenance ? (
            <>
              <Maintenance />
            </>
          ) : null}

          {hasAccess === States.Denied ? (
            <>
              <NoAccess />
            </>
          ) : null}

          {hasAccess === States.PolicyBlocked ? (
            <>
              <PolicyBlocked />
            </>
          ) : null}
          <Loader show={showLoader} message="Loading List" />
        </>
      </PrivateRoute>
    </>
  );
};

export default AppLayout;
